module.exports = __webpack_public_path__ + "static/media/icon7-3.2818fc34.png";